module.exports = __webpack_public_path__ + "img/Seby.3ae35d27.jpeg";